/* ESTO ES UN ARCHIVO AUTO GENERADO, FAVOR DE NO EDITAR, USAR bin/import.js */
import React from 'react'

import { default as CheckmarkIcon14 } from '../icons/14x14/CheckmarkIcon'
import { default as PendingIcon14 } from '../icons/14x14/PendingIcon'
import { default as CellPhoneIcon16 } from '../icons/16x16/CellPhoneIcon'
import { default as DeleteIcon16 } from '../icons/16x16/DeleteIcon'
import { default as HelpSupportIcon16 } from '../icons/16x16/HelpSupportIcon'
import { default as MailIcon16 } from '../icons/16x16/MailIcon'
import { default as SearchIcon16 } from '../icons/16x16/SearchIcon'
import { default as ApprovedIcon20 } from '../icons/20x20/ApprovedIcon'
import { default as ArchiveIcon20 } from '../icons/20x20/ArchiveIcon'
import { default as ArrowDownIcon20 } from '../icons/20x20/ArrowDownIcon'
import { default as ArrowRightIcon20 } from '../icons/20x20/ArrowRightIcon'
import { default as AttachmentIcon20 } from '../icons/20x20/AttachmentIcon'
import { default as CameraIcon20 } from '../icons/20x20/CameraIcon'
import { default as CloseIcon20 } from '../icons/20x20/CloseIcon'
import { default as ClubsInstitutionsIcon20 } from '../icons/20x20/ClubsInstitutionsIcon'
import { default as CompetitionsIcon20 } from '../icons/20x20/CompetitionsIcon'
import { default as ContactIcon20 } from '../icons/20x20/ContactIcon'
import { default as CopyIcon20 } from '../icons/20x20/CopyIcon'
import { default as DashboardIcon20 } from '../icons/20x20/DashboardIcon'
import { default as DownloadIcon20 } from '../icons/20x20/DownloadIcon'
import { default as EditIcon20 } from '../icons/20x20/EditIcon'
import { default as ImageIcon20 } from '../icons/20x20/ImageIcon'
import { default as ListIcon20 } from '../icons/20x20/ListIcon'
import { default as MoreIcon20 } from '../icons/20x20/MoreIcon'
import { default as QuestionIcon20 } from '../icons/20x20/QuestionIcon'
import { default as ScheduleIcon20 } from '../icons/20x20/ScheduleIcon'
import { default as SearchIcon20 } from '../icons/20x20/SearchIcon'
import { default as TransferIcon20 } from '../icons/20x20/TransferIcon'
import { default as UploadIcon20 } from '../icons/20x20/UploadIcon'
import { default as VenuesIcon20 } from '../icons/20x20/VenuesIcon'
import { default as AddOnsStoreIcon24 } from '../icons/24x24/AddOnsStoreIcon'
import { default as CalendarIcon24 } from '../icons/24x24/CalendarIcon'
import { default as CheckBoxIcon24 } from '../icons/24x24/CheckBoxIcon'
import { default as ClubsInstitutionsIcon24 } from '../icons/24x24/ClubsInstitutionsIcon'
import { default as CollaboratorsIcon24 } from '../icons/24x24/CollaboratorsIcon'
import { default as CompetitionsIcon24 } from '../icons/24x24/CompetitionsIcon'
import { default as ConversationsIcon24 } from '../icons/24x24/ConversationsIcon'
import { default as DashboardIcon24 } from '../icons/24x24/DashboardIcon'
import { default as DelegatesIcon24 } from '../icons/24x24/DelegatesIcon'
import { default as GetIcon24 } from '../icons/24x24/GetIcon'
import { default as InformationIcon24 } from '../icons/24x24/InformationIcon'
import { default as NotificationsIcon24 } from '../icons/24x24/NotificationsIcon'
import { default as PlayersIcon24 } from '../icons/24x24/PlayersIcon'
import { default as RefereesIcon24 } from '../icons/24x24/RefereesIcon'
import { default as SubscriptionBillingIcon24 } from '../icons/24x24/SubscriptionBillingIcon'
import { default as TeamsIcon24 } from '../icons/24x24/TeamsIcon'
import { default as TechnicalStaffIcon24 } from '../icons/24x24/TechnicalStaffIcon'
import { default as VenuesIcon24 } from '../icons/24x24/VenuesIcon'
import { default as WebsiteIcon24 } from '../icons/24x24/WebsiteIcon'
import { default as ArrowImportIcon32 } from '../icons/32x32/ArrowImportIcon'
import { default as ClubsInstitutionsIcon32 } from '../icons/32x32/ClubsInstitutionsIcon'
import { default as CollaboratorsIcon32 } from '../icons/32x32/CollaboratorsIcon'
import { default as DocumentCenterIcon32 } from '../icons/32x32/DocumentCenterIcon'
import { default as FilterIcon32 } from '../icons/32x32/FilterIcon'
import { default as FinanceIcon32 } from '../icons/32x32/FinanceIcon'
import { default as InstitutionsIcon32 } from '../icons/32x32/InstitutionsIcon'
import { default as LogOutIcon32 } from '../icons/32x32/LogOutIcon'
import { default as MessageBoardIcon32 } from '../icons/32x32/MessageBoardIcon'
import { default as MultipleCollaboratorsIcon32 } from '../icons/32x32/MultipleCollaboratorsIcon'
import { default as MultipleDelegatesIcon32 } from '../icons/32x32/MultipleDelegatesIcon'
import { default as MultipleInstitutionsIcon32 } from '../icons/32x32/MultipleInstitutionsIcon'
import { default as MultiplePlayersIcon32 } from '../icons/32x32/MultiplePlayersIcon'
import { default as MultipleRefereesIcon32 } from '../icons/32x32/MultipleRefereesIcon'
import { default as MultipleTeamsIcon32 } from '../icons/32x32/MultipleTeamsIcon'
import { default as MultipleTechincalStaffIcon32 } from '../icons/32x32/MultipleTechincalStaffIcon'
import { default as OpenIcon32 } from '../icons/32x32/OpenIcon'
import { default as ParentalControlIcon32 } from '../icons/32x32/ParentalControlIcon'
import { default as SettingsIcon32 } from '../icons/32x32/SettingsIcon'
import { default as SponsorsIcon32 } from '../icons/32x32/SponsorsIcon'
import { default as TeamsIcon32 } from '../icons/32x32/TeamsIcon'
import { ReactComponent as ArrowIcon4 } from '../icons/4x4/ArrowIcon.svg'
import { ReactComponent as DiamondIcon4 } from '../icons/4x4/Diamond.svg'

const ICONS4 = {
  ArrowIcon: <ArrowIcon4 />,
  DiamondIcon: <DiamondIcon4 />
}
const ICONS14 = {
  CheckmarkIcon: <CheckmarkIcon14 />,
  PendingIcon: <PendingIcon14 />
}
const ICONS16 = {
  CellPhoneIcon: <CellPhoneIcon16 />,
  DeleteIcon: <DeleteIcon16 />,
  HelpSupportIcon: <HelpSupportIcon16 />,
  MailIcon: <MailIcon16 />,
  SearchIcon: <SearchIcon16 />
}
const ICONS20 = {
  ApprovedIcon: <ApprovedIcon20 />,
  ArchiveIcon: <ArchiveIcon20 />,
  ArrowDownIcon: <ArrowDownIcon20 />,
  ArrowRightIcon: <ArrowRightIcon20 />,
  AttachmentIcon: <AttachmentIcon20 />,
  CameraIcon: <CameraIcon20 />,
  CloseIcon: <CloseIcon20 />,
  ClubsInstitutionsIcon: <ClubsInstitutionsIcon20 />,
  CompetitionsIcon: <CompetitionsIcon20 />,
  ContactIcon: <ContactIcon20 />,
  CopyIcon: <CopyIcon20 />,
  DashboardIcon: <DashboardIcon20 />,
  DownloadIcon: <DownloadIcon20 />,
  EditIcon: <EditIcon20 />,
  ImageIcon: <ImageIcon20 />,
  ListIcon: <ListIcon20 />,
  MoreIcon: <MoreIcon20 />,
  QuestionIcon: <QuestionIcon20 />,
  ScheduleIcon: <ScheduleIcon20 />,
  SearchIcon: <SearchIcon20 />,
  TransferIcon: <TransferIcon20 />,
  UploadIcon: <UploadIcon20 />,
  VenuesIcon: <VenuesIcon20 />
}
const ICONS24 = {
  AddOnsStoreIcon: <AddOnsStoreIcon24 />,
  CalendarIcon: <CalendarIcon24 />,
  CheckBoxIcon: <CheckBoxIcon24 />,
  ClubsInstitutionsIcon: <ClubsInstitutionsIcon24 />,
  CollaboratorsIcon: <CollaboratorsIcon24 />,
  CompetitionsIcon: <CompetitionsIcon24 />,
  ConversationsIcon: <ConversationsIcon24 />,
  DashboardIcon: <DashboardIcon24 />,
  DelegatesIcon: <DelegatesIcon24 />,
  GetIcon: <GetIcon24 />,
  InformationIcon: <InformationIcon24 />,
  NotificationsIcon: <NotificationsIcon24 />,
  PlayersIcon: <PlayersIcon24 />,
  RefereesIcon: <RefereesIcon24 />,
  SubscriptionBillingIcon: <SubscriptionBillingIcon24 />,
  TeamsIcon: <TeamsIcon24 />,
  TechnicalStaffIcon: <TechnicalStaffIcon24 />,
  VenuesIcon: <VenuesIcon24 />,
  WebsiteIcon: <WebsiteIcon24 />
}
const ICONS32 = {
  ArrowImportIcon: <ArrowImportIcon32 />,
  ClubsInstitutionsIcon: <ClubsInstitutionsIcon32 />,
  CollaboratorsIcon: <CollaboratorsIcon32 />,
  DocumentCenterIcon: <DocumentCenterIcon32 />,
  FilterIcon: <FilterIcon32 />,
  FinanceIcon: <FinanceIcon32 />,
  InstitutionsIcon: <InstitutionsIcon32 />,
  LogOutIcon: <LogOutIcon32 />,
  MessageBoardIcon: <MessageBoardIcon32 />,
  MultipleCollaboratorsIcon: <MultipleCollaboratorsIcon32 />,
  MultipleDelegatesIcon: <MultipleDelegatesIcon32 />,
  MultipleInstitutionsIcon: <MultipleInstitutionsIcon32 />,
  MultiplePlayersIcon: <MultiplePlayersIcon32 />,
  MultipleRefereesIcon: <MultipleRefereesIcon32 />,
  MultipleTeamsIcon: <MultipleTeamsIcon32 />,
  MultipleTechincalStaffIcon: <MultipleTechincalStaffIcon32 />,
  OpenIcon: <OpenIcon32 />,
  ParentalControlIcon: <ParentalControlIcon32 />,
  SettingsIcon: <SettingsIcon32 />,
  SponsorsIcon: <SponsorsIcon32 />,
  TeamsIcon: <TeamsIcon32 />
}

export { ICONS4, ICONS14, ICONS16, ICONS20, ICONS24, ICONS32 }
